import { ShippingMethod } from "../../../../../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
const mapper = {
  [ShippingMethod.Delivery]: "delivery",
  [ShippingMethod.DeliveryExpress]: "delivery",
  [ShippingMethod.Pickup]: "storePickup",
  [ShippingMethod.PickupPoint]: "servicePickup",
  [ShippingMethod.NearestPickup]: "servicePickup"
  /* SERVICE_PICKUP */
};
const mapGVShippingMethodToApplePayShippingType = (shippingMethod) => mapper[shippingMethod];
export {
  mapGVShippingMethodToApplePayShippingType
};
//# sourceMappingURL=apple-pay-shipping-types.js.map
